<p>
    Rocket Runner is an simple dodging game with unlockable skins and currency.
    It is part of a mobile web game suite I did in 2016.
</p>